import { render, staticRenderFns } from "./employeeNotes.vue?vue&type=template&id=7a178da8"
import script from "./employeeNotes.vue?vue&type=script&lang=js"
export * from "./employeeNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports